export default __webpack_public_path__ + "static/media/remove-member.1624cf92.svg";